import React from 'react';
import VerticalProgressBar from './vertical-progress-bar';
import { commaNumber } from './helpers';
import { Colors } from '../colors';

import styles from './vertical-stats-meter.css';
import classNames from 'classnames';

interface Props {
  /** Bottom of the range (x) of y */
  current: number;
  /** Top of the range x of (y) */
  max: number;
  /** Label to the right of the meter */
  label?: string;
  /** Provides visual elements for usage on a dark environment */
  darkEnv?: boolean;
}

const VerticalStatsMeter = ({ current, max, label, darkEnv }: Props) => {
  const color = darkEnv ? Colors.DodgerBlue : Colors.UnbounceBlue;

  return (
    <div className={classNames([styles.wrapper, darkEnv ? styles.darkEnv : null])}>
      <VerticalProgressBar color={color} className={styles.meter} {...{ current, max }} />
      {label && <div className={styles.label}>{label}</div>}
      <div className={styles.numbers}>{`${commaNumber(current)}/${commaNumber(max)}`}</div>
    </div>
  );
};

export default VerticalStatsMeter;
